module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isCollapsed) ? _c('select-editor-collapsed', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  }) : _c('select-editor-expanded', {
    attrs: {
      "question": _vm.value,
      "isEditable": _vm.isEditable
    },
    on: {
      "onToggleCollapse": _vm.handleToggleCollapse
    },
    model: {
      value: (_vm.computedChoices),
      callback: function($$v) {
        _vm.computedChoices = $$v
      },
      expression: "computedChoices"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25014ab3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/select/SelectEditor.vue
// module id = 3184
// module chunks = 3